import { MinusCircleOutlined, PlusOutlined } from '@ant-design/icons'
import {
  Button,
  Cascader,
  Checkbox,
  Col,
  Form,
  Input,
  Radio,
  Result,
  Row,
  Upload,
  message,
  notification,
} from 'antd'
import { useEffect, useState } from 'react'
import { getEnv } from '../../../helpers/mobx-easy-wrapper'
import qrImg from '../../../images/qr.jpg'
/*import csbmDoc from '../../../data/参赛报名表.docx'*/
import { areaOptions } from '../../../data/city'
import { color } from 'echarts'

const Enterprise = () => {
  const [form] = Form.useForm()
  const [detail, setDetail] = useState(null)
  const [fileList, setFileList] = useState([])
  const [otherFileList, setOtherFileList] = useState([])
  const [otherFileList2, setOtherFileList2] = useState([])

  const [orgFieldValue, setOrgFieldValue] = useState('')
  const [customInputState, setCustomInputState] = useState(true)

  const [otherMaterialsUrl, setOtherMaterialsUrl] = useState('')
  const [materialDefaultFileList, setMaterialDefaultFileList] = useState([])

  const [errorMsg, setErrorMsg] = useState('')
  const [resultIcon, setResultIcon] = useState('')
  const [status, setStatus] = useState(-1)
  const [availableStatus, setAvailableStatus] = useState(0)

  const [prospectusUrl, setProspectusUrl] = useState('')
  const [defaultFileList, setDefaultFileList] = useState([])

  const [converProcessFileUrl, setConverProcessFileUrl] = useState('')
  const [cpDefaultFileList, setCpDefaultFileList] = useState([])

  const [countdown, setCountdown] = useState('')
  const [uploaded, setUploaded] = useState(false)
  const [agreementA, setAgreementA] = useState(false)
  const [agreementB, setAgreementB] = useState(false)
  const [operServiceOrg, setHasOA] = useState(false)
  const [operatingAgency, setOperatingAgency] = useState(null)

  // 单位类型
  const [orgCategoryOtherInputState, setOrgCategoryOtherInputState] =
    useState(true)
  // 拟转化路径-其他
  const [converPathInputState, setConverPathInputState] = useState(true)
  const { apiFactory } = getEnv()
  const formItemLayout = {
    labelCol: {
      xs: { span: 24 },
      sm: { span: 4 },
    },
    wrapperCol: {
      xs: { span: 24 },
      sm: { span: 20 },
    },
  }
  const formItemLayoutWithOutLabel = {
    wrapperCol: {
      xs: { span: 24, offset: 0 },
      sm: { span: 20, offset: 4 },
    },
  }

  function countTime() {
    //获取当前时间
    var date = new Date()
    var now = date.getTime()
    //设置截止时间
    var str = '2022/5/10 14:30:00'
    var endDate = new Date(str)
    var end = endDate.getTime()

    //时间差
    var leftTime = end - now
    //定义变量 d,h,m,s保存倒计时的时间
    var d, h, m, s
    if (leftTime >= 0) {
      d = Math.floor(leftTime / 1000 / 60 / 60 / 24)
      h = Math.floor((leftTime / 1000 / 60 / 60) % 24)
      m = Math.floor((leftTime / 1000 / 60) % 60)
      s = Math.floor((leftTime / 1000) % 60)
    }
    //将0-9的数字前面加上0，例1变为01
    d = checkTime(d)
    h = checkTime(h)
    m = checkTime(m)
    s = checkTime(s)
    function checkTime(i: any) {
      if (i < 10) {
        i = '0' + i
      }
      return i
    }
    // console.log()
    setCountdown(`距离报名时间还有${d}天${h}时${m}分`)
    //递归每秒调用countTime方法，显示动态时间效果
    setTimeout(countTime, 1000)
  }

  // 辅助函数：检查是否选择了"其他"并验证输入内容
  const validateOtherType = (form) => ({
    validator(_, value) {
      const selectedValue = form.getFieldValue('type')
      const otherInputValue = form.getFieldValue('typeOther')

      if (selectedValue === '其他') {
        if (!otherInputValue || otherInputValue.trim() === '') {
          return Promise.reject(new Error('请输入其他单位类型'))
        } else {
          // 输入有效时，清除该字段的错误提示
          form.setFields([
            {
              name: 'typeOther',
              errors: undefined,
            },
          ])
          return Promise.resolve()
        }
      }
      return Promise.resolve()
    },
  })

  useEffect(() => {
    async function checkAvailable() {
      const checkData = await apiFactory.techService.checkAvailble()
      if (checkData.status == 0) {
        // getDetail();
      } else {
        if (status === -1) {
          setErrorMsg(checkData.msg)
        }
        setResultIcon('error')
        setAvailableStatus(checkData.status)
      }
      getDetail()
    }
    countTime()
    async function getDetail() {
      const result = await apiFactory.activityService.getWorksDetail()
      if (result.status == 401) {
        message.error('用户未登录，请先登录')
        ;(document.getElementById('loginHeader') as HTMLDivElement).click()
        return
      }
      // result && setStatus(result.status);
      if (result.patentStatus == 2) {
        console.log(888888)

        setResultIcon('info')
        setErrorMsg('您已在【未转化组】提交，请勿重复提交')
        setStatus(null)
        setDetail(result)
      }
      /* 回调处理数据 */
      if (result && result.patentStatus == 1) {
        result.prospectusUrl.split(',').forEach((url: string, i: number) => {
          const temp = url.split('/')
          const fileName = temp[temp.length - 1]
          setDefaultFileList((val) => {
            ;(val as any).push({
              uid: i,
              name: fileName,
              status: 'done',
              url: url,
            })
            return val
          })
        })
        console.log(2222, result)

        result.orgName && (result.orgName = result.orgName.split(','))
        if (result.operServiceOrg) {
          setHasOA(result.operServiceOrg)
        }
        if (result.operatingAgency) {
          setOperatingAgency(result.operatingAgency)
        }
        if (result.proField) {
          const dataSet = [
            '生命健康与智慧医疗',
            '新一代信息技术与通信',
            '绿色能源与碳中和',
            '人工智能与智能生态',
            '先进制造与高端装备',
            '合成生物与生物制造',
            '先进材料',
          ]
          if (dataSet.indexOf(result.proField) > -1) {
            setCustomInputState(true)
          } else {
            setOrgFieldValue(result.proField)
            result.proField = 'custom'
            // 设置自定义输入框不可用
            setCustomInputState(false)
          }
        }
        result.orgCategory &&
          (result.orgCategory = result.orgCategory.split(','))
        // 单独处理回写附件问题
        form.setFieldsValue({
          ...result,
          prospectusUrl: [],
          converProcessFile: [],
          otherMaterialsUrl: [],
        })
        // 修复以逗号开始得错误数据
        if (result.prospectusUrl && result.prospectusUrl.startsWith(',')) {
          result.prospectusUrl = result.prospectusUrl.replace(',', '')
        }
        if (result.prospectusUrl) {
          setUploaded(true)
          // 填充文件名
          const arr = (result.prospectusUrl.split(',') || []).map(
            (url: string, i: number) => {
              const temp = url.split('/')
              const fileName = temp[temp.length - 1]
              return {
                uid: i,
                name: fileName,
                status: 'done',
                url: url,
              }
            }
          )
          setProspectusUrl(result.prospectusUrl)
          setDefaultFileList(arr)
          form.setFieldsValue({ prospectusUrl: arr })
        }

        if (result.otherMaterialsUrl) {
          setUploaded(true)
          // 填充文件名
          const arr = (result.otherMaterialsUrl.split(',') || []).map(
            (url: string, i: number) => {
              const temp = url.split('/')
              const fileName = temp[temp.length - 1]
              return {
                uid: 'material_' + i,
                name: fileName,
                status: 'done',
                url: url,
              }
            }
          )

          setOtherMaterialsUrl(result.otherMaterialsUrl)
          setMaterialDefaultFileList(arr)
          form.setFieldsValue({ otherMaterialsUrl: arr })
        }

        if (result.converProcessFile) {
          setUploaded(true)
          // 填充文件名
          const arr = result.converProcessFile
            .split(',')
            .map((url: string, i: number) => {
              const temp = url.split('/')
              const fileName = temp[temp.length - 1]
              return {
                uid: 'converProcessFileUrl_' + i,
                name: fileName,
                status: 'done',
                url: url,
              }
            })
          setConverProcessFileUrl(result.converProcessFile)
          setCpDefaultFileList(arr)
          form.setFieldsValue({ converProcessFile: arr })
        }
        console.log(33333333, form.getFieldsValue(), result)
        switch (result.status) {
          case 0:
            setResultIcon('info')
            setErrorMsg(
              '报名成功！请用微信扫描二维码添加小助手进入大赛群组，接收线上培训公开课信息及大赛后续安排事宜。申请时请备注项目名称。'
            )
            break
          case 1:
            setResultIcon('error')
            setErrorMsg(
              `很抱歉您未通过审核，失败的理由为：${result.failReason}`
            )
            break
          case 2:
            setResultIcon('success')
            setErrorMsg('您已通过审核，现阶段进入专家评分阶段。')
            break
          default:
            // setResultIcon('success')
            // setErrorMsg('您已通过审核，现阶段进入专家评分阶段。')
            return
        }
        setStatus(result.status)
        /*if (result.status === 1) {
                                setErrorMsg(result.failReason);
                              }*/
        setDetail(result)
      }
      // console.log(result);
    }
    checkAvailable()
    // getDetail();
  }, [])

  const onFinish = (values: any) => {
    // console.log("Received values of form: ", values);
  }

  const normFile = (e: any) => {
    console.log('Upload event:', e)
    if (!e) return []
    if (Array.isArray(e)) {
      return e
    }
    return e && e.fileList
  }

  function beforeUpload(file: any) {
    const isLt2M = file.size / 1024 / 1024 < 50
    if (!isLt2M) {
      message.error('文件大小必须小于50mb!')
    }
    return isLt2M
  }

  const handleUpload = async (
    option: any,
    key: any,
    setVal: any,
    setArray: any
  ) => {
    const file = option.file as File
    try {
      const result = await apiFactory.techService.upload(file)
      if (result.status === 200) {
        //const tempUrlArray = prospectusUrl.split(',');
        const tempUrlArray = key.length == 0 ? [] : key.split(',')
        tempUrlArray.push(result.data.downloadUrl)

        // setProspectusUrl(tempUrlArray.join(','));
        setVal(tempUrlArray.join(','))

        console.log(777, tempUrlArray, otherMaterialsUrl)
        option.onSuccess(result.url)
        // setDefaultFileList([]);
        // setArray([])
      } else {
        message.error('文件上传失败')
      }
    } catch (error) {
      message.error('文件上传失败')
      option.onError(error)
    }
  }

  function showTip() {
    notification.info({
      message: `报名未开始 `,
      description: countdown,
      placement: 'top',
    })
  }
  const changeCustomInput = (event: any) => {
    if (event.target.value.indexOf('custom') > -1) {
      setCustomInputState(false)
    } else {
      setCustomInputState(true)
    }
  }

  const changeHasAgency = (event: any) => {
    if (event.target.value == false) {
      form.setFieldsValue({ operatingAgency: '' })
    }
    setHasOA(event.target.value)
  }

  const updateHasOAValidator = () => {
    form.validateFields(['operServiceOrg'])
  }

  const removeUploadFile = (file: any, key: any, setVal: any) => {
    const tempArray = key.split(',')
    tempArray.forEach((item: any, index: any) => {
      item.endsWith(file.name)
      tempArray.splice(index, 1)
    })
    setVal(tempArray.join(','))
  }

  const submitForm = async () => {
    console.log(333, form.getFieldsValue())
    //form.submit();
    if (!apiFactory.authService.isAuthenticated()) {
      message.error('用户未登录，请先登录')
      return
    }
    if ((window as any)['enterStatus'] === 2) {
      message.error('您的企业报名已审核成功，无需再次报名！')
      return
    }

    try {
      const values = await form.validateFields()
    } catch (e) {
      return
    }

    // console.log("Success:", values);
    const formData = form.getFieldsValue()

    // if (
    //   !prospectusUrl &&
    //   (!formData.recentStatus ||
    //     !formData.marketSize ||
    //     !formData.proOperation ||
    //     !formData.basicInformation ||
    //     !formData.coreTeam)
    // ) {
    //   message.warn('请填写项目基本信息或者上传附件')
    //   return
    // }
    formData.patentStatus = 1 // 已转化
    // 附件
    formData.otherMaterialsUrl = otherMaterialsUrl
    formData.prospectusUrl = prospectusUrl
    formData.converProcessFile = converProcessFileUrl

    formData.orgName && (formData.orgName = formData.orgName.join(','))
    formData.orgCategory &&
      (formData.orgCategory = formData.orgCategory.join(','))

    if (formData.proField && formData.proField.indexOf('custom') > -1) {
      /*if (
                          formData.orgField[formData.orgField.length - 1].indexOf('custom') > -1
                        ) {
                          formData.orgField[
                            formData.orgField.length - 1
                          ] = `custom_${orgFieldValue}`;
                        }
                        formData.orgField = formData.orgField.join(',');*/
      formData.proField = orgFieldValue
    }

    formData.id = detail && (detail as any).id
    console.log('formData.id', formData.id)
    const finalData = Object.assign(detail || {}, formData)
    console.log('finalData', finalData)
    const res = await apiFactory.techService
      .postRegistrationForm(finalData)
      .catch((error) => {
        message.error('提交失败 ' + error.data.message)
      })
    if (res.status === 401) {
      message.error('用户未登录，请先登录')
      return
    } else if (res.status && res.status != 200) {
      message.error(res.message || '提交错误')
      return
    }

    message.success('提交成功')
    setTimeout(() => {
      window.location.reload()
    }, 300)
  }

  return (
    <div className="home">
      <>
        {(availableStatus === -1 && !detail) || status > -1 ? (
          <Result
            status={resultIcon as any}
            title={errorMsg}
            subTitle=""
            extra={[
              status === 1 ? (
                <Button
                  type="primary"
                  key="console"
                  onClick={() => setStatus(-1)}>
                  重新编辑
                </Button>
              ) : (
                <></>
              ),
              status === 0 ? (
                <div>
                  <img src={qrImg} />
                </div>
              ) : (
                <></>
              ),
            ]}
          />
        ) : (
          <>
            <div className="subTitle-zh" style={{ marginBottom: '48px' }}>
              1. 基本情况
            </div>

            <Form
              name="complex-form"
              form={form}
              onFinish={onFinish}
              labelWrap
              labelCol={{ span: 4 }}
              wrapperCol={{ span: 21 }}
              style={{ marginBottom: '68px', fontSize: '18px' }}>
              <Form.List
                name="orgName"
                initialValue={['']}
                rules={[
                  {
                    validator: async (_, names) => {
                      if (!names || names.length < 1) {
                        return Promise.reject(
                          new Error('At least 1 passengers')
                        )
                      }
                    },
                  },
                ]}>
                {(fields, { add, remove }, { errors }) => (
                  <>
                    {fields.map((field, index) => (
                      <Form.Item
                        {...formItemLayout}
                        extra={index === 0 ? '*第一单位默认为牵头单位' : ''}
                        required={false}
                        key={field.key + 1}>
                        <Form.Item
                          {...field}
                          validateTrigger={['onChange', 'onBlur']}
                          rules={[
                            {
                              required: true,
                              whitespace: true,
                              message: '单位名称不能为空',
                            },
                          ]}
                          noStyle>
                          <Input
                            placeholder="参赛单位名称"
                            style={{ width: '60%' }}
                          />
                        </Form.Item>
                        {fields.length > 1 ? (
                          <MinusCircleOutlined
                            className="dynamic-delete-button"
                            onClick={() => remove(field.name)}
                          />
                        ) : null}
                      </Form.Item>
                    ))}
                    <Form.Item>
                      <Button
                        type="dashed"
                        disabled={fields.length === 4}
                        onClick={() => add()}
                        style={{ width: '60%' }}
                        icon={<PlusOutlined />}>
                        添加参赛单位
                      </Button>
                    </Form.Item>
                  </>
                )}
              </Form.List>

              {/* 
            <Form.Item extra="*第一单位默认为牵头单位">
              <Form.Item
                name="username"
                noStyle
                rules={[{ required: true, message: "单位名称不能为空" }]}
              >
                <Input style={{ width: 240 }} placeholder="参赛单位名称" />
              </Form.Item>
              {unitNames.length > 1 ? (
                <MinusCircleOutlined
                  className="dynamic-delete-button"
                  onClick={() => remove(index)}
                />
              ) : null}
            </Form.Item> */}

              <Form.Item
                name="type"
                label="单位类型："
                validateTrigger={['onChange', 'onBlur']}
                labelAlign="left"
                rules={[
                  {
                    required: true,
                    message: '单位类型不能为空',
                  },
                  validateOtherType(form),
                ]}>
                <Radio.Group
                  onChange={(val) => {
                    setOrgCategoryOtherInputState(val.target.value !== '其他')
                    // 当取消选择"其他"时，清空输入框
                    if (val.target.value !== '其他') {
                      form.setFieldsValue({ typeOther: '' })
                    }
                  }}>
                  <Row>
                    <Radio value="高校">高校</Radio>
                    <Radio value="科研院所">科研院所</Radio>
                    <Radio value="医疗卫生机构">医疗卫生机构</Radio>
                    <Radio value="企业">企业</Radio>
                    <Radio value="科创团队">科创团队</Radio>
                    <Radio value="其他">
                      其他
                      <Form.Item
                        name="typeOther"
                        noStyle
                        validateTrigger={['onChange', 'onBlur']}>
                        <Input
                          style={{ width: 140, marginLeft: '10px' }}
                          placeholder="请输入其他内容"
                          disabled={orgCategoryOtherInputState}
                          onChange={(e) => {
                            form.setFieldsValue({ typeOther: e.target.value })
                            // 实时校验输入内容
                            form.validateFields(['type']).catch(() => {})
                          }}
                        />
                      </Form.Item>
                    </Radio>
                  </Row>
                </Radio.Group>
              </Form.Item>

              <Form.Item
                name="operServiceOrg"
                label="是否有运营服务机构:"
                labelAlign="left"
                rules={[
                  {
                    required: true,
                    message: '有运营服务机构不能为空',
                  },
                  {
                    validator: async (_, val) => {
                      const operatingAgency =
                        form.getFieldValue('operatingAgency')
                      const selectedValue = form.getFieldValue('operServiceOrg')
                      if (selectedValue == true) {
                        if (!operatingAgency || operatingAgency.trim() === '') {
                          return Promise.reject('有运营服务机构不能为空')
                        } else {
                          // 输入有效时，清除该字段的错误提示
                          form.setFields([
                            {
                              name: 'operatingAgency',
                              errors: undefined,
                            },
                          ])
                          return Promise.resolve()
                        }
                      }
                      return Promise.resolve()
                    },
                  },
                ]}>
                <Radio.Group onChange={changeHasAgency}>
                  <Row>
                    <Radio value={false}>否</Radio>
                    <Radio value={true}>是</Radio>
                    <Form.Item noStyle name="operatingAgency">
                      <Input
                        style={{ width: 140 }}
                        placeholder="请填写"
                        disabled={!operServiceOrg}
                        onChange={(e) => {
                          setOperatingAgency(e.target.value)
                          updateHasOAValidator()
                          form.setFieldsValue({
                            operatingAgency: e.target.value,
                          })
                          // 实时校验输入内容
                          form
                            .validateFields(['operServiceOrg'])
                            .catch(() => {})
                        }}
                      />
                    </Form.Item>
                  </Row>
                </Radio.Group>
              </Form.Item>

              <Form.Item
                name="regions"
                label="所属地区:"
                labelAlign="left"
                rules={[
                  {
                    required: true,
                    message: '请选择所属区县',
                  },
                ]}>
                <Cascader
                  style={{ width: 500 }}
                  options={areaOptions}
                  placeholder="请选择所属区县"
                />
              </Form.Item>

              {/* <Form.Item
                            name='isPCT'
                            label='是否有PCT专利:'
                            labelAlign='left'
                            rules={[
                                {
                                    required: true,
                                    message: '是否有PCT专利',
                                },
                            ]}
                        >
                            <Radio.Group >
                                <Row>
                                    <Radio value={0}>否</Radio>
                                    <Radio value={1}>是</Radio>
                                </Row>
                            </Radio.Group>
                        </Form.Item> */}

              <Form.Item style={{ marginBottom: 0 }}>
                <Form.Item
                  name="contactUser"
                  validateTrigger={['onChange', 'onBlur']}
                  rules={[
                    {
                      required: true,
                      whitespace: true,
                      message: '联系人不能为空',
                    },
                  ]}
                  style={{ display: 'inline-block', width: 240 }}>
                  <Input placeholder="联系人" />
                </Form.Item>
                <Form.Item
                  name="contactPhone"
                  validateTrigger={['onChange', 'onBlur']}
                  rules={[
                    {
                      required: true,
                      whitespace: true,
                      message: '电话不能为空',
                    },
                  ]}
                  style={{
                    display: 'inline-block',
                    width: 240,
                    margin: '0 8px',
                  }}>
                  <Input placeholder="电话" />
                </Form.Item>
                <Form.Item
                  name="post"
                  validateTrigger={['onChange', 'onBlur']}
                  rules={[
                    {
                      required: true,
                      whitespace: true,
                      message: '职务不能为空',
                    },
                  ]}
                  style={{
                    display: 'inline-block',
                    width: 240,
                    margin: '0 8px',
                  }}>
                  <Input placeholder="职务" />
                </Form.Item>
              </Form.Item>
              <Form.Item
                name="worksName"
                label="参赛项目名称："
                labelAlign="left"
                validateTrigger={['onChange', 'onBlur']}
                rules={[
                  {
                    required: true,
                    whitespace: true,
                    message: '参赛项目名称不能为空',
                  },
                ]}>
                <Input style={{ width: 490 }} placeholder="参赛项目名称" />
              </Form.Item>

              <Form.List
                name="patentJson"
                initialValue={[{}]}
                rules={[
                  {
                    validator: async (_, names) => {
                      if (!names || names.length < 1) {
                        return Promise.reject(
                          new Error('At least 1 passengers')
                        )
                      }
                    },
                  },
                ]}>
                {(fields, { add, remove }, { errors }) => (
                  <>
                    {fields.map(({ key, name, ...restField }) => (
                      <div
                        key={`zl_${key}`}
                        style={{
                          width: '100%',
                          display: 'flex',
                          alignItems: 'center',
                          marginBottom: fields.length - 1 !== name ? 25 : 5,
                          borderBottom:
                            fields.length - 1 !== name
                              ? '1px dashed #d9d9d9'
                              : '',
                        }}>
                        <div style={{ width: '100%' }}>
                          <div
                            style={{
                              width: '100%',
                              display: 'flex',
                              marginBottom: 1,
                            }}>
                            <Form.Item
                              {...restField}
                              name={[name, 'patentNo']}
                              style={{ display: 'inline-block', width: 200 }}
                              rules={[
                                { required: true, message: '专利号不能为空' },
                              ]}>
                              <Input placeholder="专利号" />
                            </Form.Item>
                            <Form.Item
                              {...restField}
                              name={[name, 'patentName']}
                              style={{ display: 'inline-block', width: 200 }}
                              rules={[
                                { required: true, message: '专利名称不能为空' },
                              ]}>
                              <Input placeholder="专利名称" />
                            </Form.Item>
                            <Form.Item
                              {...restField}
                              name={[name, 'patentUsers']}
                              style={{ display: 'inline-block', width: 200 }}
                              rules={[{ required: true, message: '专利权人' }]}>
                              <Input placeholder="专利权人" />
                            </Form.Item>
                          </div>

                          <div>
                            <Form.Item
                              {...restField}
                              name={[name, 'patentType']}
                              label="专利类型:"
                              labelAlign="left"
                              rules={[
                                {
                                  required: true,
                                  message: '专利类型',
                                },
                              ]}>
                              <Radio.Group style={{ width: 600 }}>
                                <Row>
                                  <Radio value="发明">发明</Radio>
                                  <Radio value="实用新型">实用新型</Radio>
                                  <Radio value="外观设计">外观设计</Radio>
                                </Row>
                              </Radio.Group>
                            </Form.Item>
                            <Form.Item
                              {...restField}
                              name={[name, 'patentPct']}
                              label="是否申请PCT:"
                              labelAlign="left"
                              rules={[
                                {
                                  required: true,
                                  message: '是否申请PCT',
                                },
                              ]}>
                              <Radio.Group style={{ width: 600 }}>
                                <Row>
                                  <Radio value="是（含正在申请）">
                                    是（含正在申请）
                                  </Radio>
                                  <Radio value="否">否</Radio>
                                  <Radio value="计划申请">计划申请</Radio>
                                </Row>
                              </Radio.Group>
                            </Form.Item>
                          </div>
                        </div>
                        {fields.length > 1 && (
                          <MinusCircleOutlined onClick={() => remove(name)} />
                        )}
                      </div>
                    ))}
                    <Form.Item>
                      <Button
                        type="dashed"
                        disabled={fields.length === 3}
                        onClick={() => add()}
                        style={{ width: '60%' }}
                        icon={<PlusOutlined />}>
                        添加专利
                      </Button>
                    </Form.Item>
                  </>
                )}
              </Form.List>

              <Form.Item
                name="proField"
                label="项目领域:"
                labelAlign="left"
                rules={[
                  {
                    required: true,
                    whitespace: true,
                    message: '项目领域不能为空',
                  },
                ]}>
                <Radio.Group onChange={changeCustomInput}>
                  <Row>
                    <Radio value="生命健康与智慧医疗">生命健康与智慧医疗</Radio>
                    <Radio value="新一代信息技术与通信">
                      新一代信息技术与通信
                    </Radio>
                    <Radio value="绿色能源与碳中和">绿色能源与碳中和</Radio>
                    <Radio value="人工智能与智能生态">人工智能与智能生态</Radio>
                    <Radio value="先进制造与高端装备">先进制造与高端装备</Radio>
                    <Radio value="合成生物与生物制造">合成生物与生物制造</Radio>
                    <Radio value="先进材料">先进材料</Radio>
                    <Radio value="custom">
                      <Input
                        disabled={customInputState}
                        style={{ width: 140 }}
                        placeholder="其他"
                        value={orgFieldValue}
                        onChange={(e) => setOrgFieldValue(e.target.value)}
                      />
                    </Radio>
                  </Row>
                </Radio.Group>
              </Form.Item>
              <Form.Item
                name="isOpen"
                label="专利开放许可意愿:"
                labelAlign="left"
                style={{ marginTop: '55px' }}
                rules={[
                  {
                    required: true,
                    message: '专利开放许可意愿不能为空',
                  },
                ]}>
                <Radio.Group>
                  <Row>
                    <Radio value={true} style={{ lineHeight: '32px' }}>
                      愿意
                    </Radio>
                    <Radio value={false} style={{ lineHeight: '32px' }}>
                      暂不考虑
                    </Radio>
                  </Row>
                </Radio.Group>
              </Form.Item>
              <Form.Item
                name="rightPledge"
                label="知识产权质押融资意愿:"
                labelAlign="left"
                style={{ marginTop: '55px' }}
                rules={[
                  {
                    required: true,
                    message: '项目路演及投融资意愿不能为空',
                  },
                ]}>
                <Radio.Group>
                  <Row>
                    <Radio value={true} style={{ lineHeight: '32px' }}>
                      愿意
                    </Radio>
                    <Radio value={false} style={{ lineHeight: '32px' }}>
                      暂不考虑
                    </Radio>
                  </Row>
                </Radio.Group>
              </Form.Item>
              <Form.Item
                name="roadshow"
                label="项目路演及投融资意愿:"
                labelAlign="left"
                style={{ marginTop: '55px' }}
                rules={[
                  {
                    required: true,
                    message: '项目路演及投融资意愿不能为空',
                  },
                ]}>
                <Radio.Group>
                  <Row>
                    <Radio value={true} style={{ lineHeight: '32px' }}>
                      愿意
                    </Radio>
                    <Radio value={false} style={{ lineHeight: '32px' }}>
                      暂不考虑
                    </Radio>
                  </Row>
                </Radio.Group>
              </Form.Item>
              <Form.Item
                name="techTransfer"
                label="技术转化及交易意愿:"
                labelAlign="left"
                style={{ marginTop: '55px' }}
                rules={[
                  {
                    required: true,
                    message: '技术转化及交易意愿不能为空',
                  },
                ]}>
                <Radio.Group>
                  <Row>
                    <Radio value={true} style={{ lineHeight: '32px' }}>
                      愿意
                    </Radio>
                    <Radio value={false} style={{ lineHeight: '32px' }}>
                      暂不考虑
                    </Radio>
                  </Row>
                </Radio.Group>
              </Form.Item>
              <Form.Item
                name="disseminate"
                label="品牌传播意愿:"
                labelAlign="left"
                style={{ marginTop: '55px' }}
                rules={[
                  {
                    required: true,
                    message: '传播意愿不能为空',
                  },
                ]}>
                <Radio.Group>
                  <Row>
                    <Radio value={true} style={{ lineHeight: '32px' }}>
                      愿意
                    </Radio>
                    <Radio value={false} style={{ lineHeight: '32px' }}>
                      暂不考虑
                    </Radio>
                  </Row>
                </Radio.Group>
              </Form.Item>
              <Form.Item
                name="regIntent"
                label="扩产、搬迁注册意愿:"
                labelAlign="left"
                style={{ marginTop: '55px' }}
                rules={[
                  {
                    required: true,
                    message: '扩产、搬迁注册意愿不能为空',
                  },
                ]}>
                <Radio.Group>
                  <Row>
                    <Radio value={true} style={{ lineHeight: '32px' }}>
                      愿意
                    </Radio>
                    <Radio value={false} style={{ lineHeight: '32px' }}>
                      暂不考虑
                    </Radio>
                  </Row>
                </Radio.Group>
              </Form.Item>
              <p className="uploadTips fontColor">
                <a
                  href={process.env.PUBLIC_URL + '/enterprise/参赛报名表.docx'}>
                  下载报名表模板
                </a>{' '}
                <div style={{ color: '#999999', fontSize: '14px' }}>
                  可直接下载填写报名表，上传至补充资料
                </div>
                {/* <a href={process.env.PUBLIC_URL + '/enterprise/商业计划书模板.pptx'} style={{ marginLeft: '64px' }}>
                                    下载商业计划书模板
                                </a> */}
              </p>
              <Form.Item
                name="otherMaterialsUrl"
                valuePropName="fileList"
                getValueFromEvent={normFile}>
                <Upload
                  name="logo"
                  multiple={false}
                  // maxCount={5}
                  customRequest={(opt) => {
                    handleUpload(
                      opt,
                      otherMaterialsUrl,
                      setOtherMaterialsUrl,
                      setMaterialDefaultFileList
                    )
                  }}
                  beforeUpload={beforeUpload}
                  onRemove={(i) => {
                    // setProspectusUrl('');
                    removeUploadFile(i, otherMaterialsUrl, setOtherMaterialsUrl)
                  }}
                  fileList={otherFileList}
                  defaultFileList={materialDefaultFileList}>
                  <Button className="uploadButton" type="default">
                    <div>上传补充资料 （非必传）</div>
                    <div style={{ color: '#999999' }}>文件不大于50M</div>
                    <div style={{ color: '#999999' }}>
                      支持PPT、PDF、PNG、JPG格式
                    </div>
                  </Button>
                  <p className="uploadTips">
                    * 补充资料可上传多个附件，最多为5个
                  </p>
                </Upload>
              </Form.Item>

              <div style={{ display: 'inline-block' }}>
                <Form.Item
                  name="prospectusUrl"
                  valuePropName="fileList"
                  getValueFromEvent={normFile}>
                  <Upload
                    name="logo"
                    multiple
                    maxCount={5}
                    customRequest={(opt) => {
                      handleUpload(
                        opt,
                        prospectusUrl,
                        setProspectusUrl,
                        setDefaultFileList
                      )
                    }}
                    beforeUpload={beforeUpload}
                    onRemove={(i) => {
                      //setProspectusUrl('');
                      removeUploadFile(i, prospectusUrl, setProspectusUrl)
                    }}
                    fileList={fileList}
                    defaultFileList={defaultFileList}>
                    <Button className="uploadButton" type="default">
                      <div>上传商业计划书 （非必传）</div>
                      <div style={{ color: '#999999' }}>文件不大于50M</div>
                      <div style={{ color: '#999999' }}>支持PPT、PDF格式</div>
                    </Button>
                  </Upload>
                </Form.Item>

                <Row>
                  <Checkbox
                    checked={uploaded}
                    disabled={!prospectusUrl}
                    onChange={() => {
                      console.log('change', !uploaded)

                      setUploaded(!uploaded)
                    }}
                    value="高校">
                    本项目以商业计划书形式参赛，以下2.1内容不填写。
                  </Checkbox>
                </Row>
                {/*  <p>如果商业计划书中包含以下内容，以下内容可不用填写。</p>*/}
              </div>
              <div className="subTitle-zh" style={{ marginTop: '68px' }}>
                2. 项目信息
              </div>

              {/* row 1*/}
              <Form.Item name="radio-group">
                <div className="subTitle" style={{ marginTop: '50px' }}>
                  2.1 参赛项目基本情况
                </div>
              </Form.Item>

              <Row gutter={[16, 16]}>
                <Col span={'11'}>
                  <label className="form-label">
                    项目基本情况（内容包括但不限于:立项时间、项目投入、实施过程、商业模式、社会效益、获奖情况、配套资源、知识产权质押融资和证券化计划或实施情况等。）
                  </label>
                </Col>
                <Col span={'11'} offset={1}>
                  <label className="form-label">
                    核心团队（至少应当包括但不限于项目研发人员数量、研发经历、研发成果以及项目管理、运营、推广团队的人员情况，参赛项目团队个人经历介绍等）{' '}
                  </label>
                </Col>
              </Row>

              <Row gutter={[16, 16]} style={{ marginTop: '15px' }}>
                <Col span={'11'}>
                  <Form.Item
                    name="basicInformation"
                    rules={[
                      {
                        validator: async (_, names) => {
                          if (uploaded) {
                            return Promise.resolve()
                          }
                          if ((names && names.trim().length < 10) || !names) {
                            return Promise.reject(
                              new Error('请输入至少10个字符')
                            )
                          }
                        },
                      },
                    ]}>
                    <Input.TextArea rows={4} disabled={uploaded} />
                  </Form.Item>
                </Col>

                <Col span={'11'} offset={1}>
                  <Form.Item
                    name="corePatentInfo"
                    rules={[
                      {
                        validator: async (_, names) => {
                          if (uploaded) {
                            return Promise.resolve()
                          }
                          if ((names && names.trim().length < 10) || !names) {
                            return Promise.reject(
                              new Error('请输入至少10个字符')
                            )
                          }
                        },
                      },
                    ]}>
                    <Input.TextArea rows={4} disabled={uploaded} />
                  </Form.Item>
                </Col>
              </Row>
              {/* row 2 */}
              <Row gutter={[16, 16]}>
                <Col span={'11'}>
                  <label className="form-label">
                    与本项目技术相关的已公开专利列表：（非必填）至少包括申请号/公开号、发明名称等信息。
                  </label>
                </Col>
                <Col span={'11'} offset={1}>
                  <label className="form-label">
                    核心团队介绍：至少包括但不限于项目研发人员数量、研发经历、研发成果以及项目管理、运营、推广团队的人员情况，参赛项目团队个人经历介绍等。{' '}
                  </label>
                </Col>
              </Row>

              <Row gutter={[16, 16]} style={{ marginTop: '15px' }}>
                <Col span={'11'}>
                  <Form.Item noStyle name="patentList">
                    <Input.TextArea rows={4} disabled={uploaded} />
                  </Form.Item>
                </Col>

                <Col span={'11'} offset={1}>
                  <Form.Item
                    name="coreTeam"
                    rules={[
                      {
                        validator: async (_, names) => {
                          if (uploaded) {
                            return Promise.resolve()
                          }
                          if ((names && names.trim().length < 10) || !names) {
                            return Promise.reject(
                              new Error('请输入至少10个字符')
                            )
                          }
                        },
                      },
                    ]}>
                    <Input.TextArea rows={4} disabled={uploaded} />
                  </Form.Item>
                </Col>
              </Row>

              {/* row 3 */}
              <Row gutter={[16, 16]}>
                <Col span={'11'}>
                  <label className="form-label">
                    市场规模：目标客户、适用场景、国内外市场规模预测等。
                  </label>
                </Col>
                <Col span={'11'} offset={1}>
                  <label className="form-label">
                    近三年收入状况以及未来三年收入预期：成立时间未满三年的企业，按实际存在时间填写。{' '}
                  </label>
                </Col>
              </Row>

              <Row gutter={[16, 16]} style={{ marginTop: '15px' }}>
                <Col span={'11'}>
                  <Form.Item
                    name="marketSize"
                    rules={[
                      {
                        validator: async (_, names) => {
                          if (uploaded) {
                            return Promise.resolve()
                          }
                          if ((names && names.trim().length < 10) || !names) {
                            return Promise.reject(
                              new Error('请输入至少10个字符')
                            )
                          }
                        },
                      },
                    ]}>
                    <Input.TextArea rows={4} disabled={uploaded} />
                  </Form.Item>
                </Col>

                <Col span={'11'} offset={1}>
                  <Form.Item
                    name="recentStatus"
                    rules={[
                      {
                        validator: async (_, names) => {
                          if (uploaded) {
                            return Promise.resolve()
                          }
                          if ((names && names.trim().length < 10) || !names) {
                            return Promise.reject(
                              new Error('请输入至少10个字符')
                            )
                          }
                        },
                      },
                    ]}>
                    <Input.TextArea rows={4} disabled={uploaded} />
                  </Form.Item>
                </Col>
              </Row>

              <Form.Item name="radio-group" style={{ marginTop: '25px' }}>
                <div className="subTitle" style={{ marginTop: '25px' }}>
                  2.2 核心专利转化运用成效
                </div>
              </Form.Item>

              <Form.Item
                name="converPath"
                label="已转化路径"
                labelAlign="left"
                style={{ marginTop: '25px' }}
                rules={[
                  // {
                  //   required: !uploaded,
                  //   message: '请选择',
                  // },
                  {
                    required: true,
                    message: '请选择',
                  },
                  {
                    validator(_, value) {
                      const selectedValue = form.getFieldValue('converPath')
                      const otherInputValue =
                        form.getFieldValue('converPathOther')

                      if (selectedValue === '其他') {
                        if (!otherInputValue || otherInputValue.trim() === '') {
                          return Promise.reject(new Error('请输入其他内容'))
                        } else {
                          // 输入有效时，清除该字段的错误提示
                          form.setFields([
                            {
                              name: 'converPathOther',
                              errors: undefined,
                            },
                          ])
                          return Promise.resolve()
                        }
                      }
                      return Promise.resolve()
                    },
                  },
                ]}>
                <Radio.Group
                  onChange={(val) => {
                    setConverPathInputState(val.target.value !== '其他')
                    // 当取消选择"其他"时，清空输入框
                    if (val.target.value !== '其他') {
                      form.setFieldsValue({ converPathOther: '' })
                    }
                  }}>
                  <Row>
                    <Radio value="技术转让">技术转让</Radio>
                    <Radio value="技术许可">技术许可</Radio>
                    <Radio value="作价入股">作价入股</Radio>
                    <Radio value="其他">
                      其他
                      <Form.Item
                        name="converPathOther"
                        noStyle
                        validateTrigger={['onChange', 'onBlur']}>
                        <Input
                          style={{ width: 140, marginLeft: '10px' }}
                          placeholder="请输入其他内容"
                          disabled={converPathInputState}
                          onChange={(e) => {
                            form.setFieldsValue({
                              converPathOther: e.target.value,
                            })
                            // 实时校验输入内容
                            form.validateFields(['converPath']).catch(() => {})
                          }}
                        />
                      </Form.Item>
                    </Radio>
                  </Row>
                </Radio.Group>
              </Form.Item>

              <p style={{ color: 'red' }}>
                特别提示：今年新增转化路径奖，如您认为在以上的转化路径过程中有突出表现，请重点回答以下问题2、3、4。
              </p>
              <Row gutter={[16, 16]}>
                <Col span={'11'}>
                  <label className="form-label">
                    请描述核心专利的转化实施过程，并提交相关转化凭证材料（如有，请提交附件）：
                  </label>
                </Col>
                <Col span={'11'} offset={1}>
                  <label className="form-label">
                    {/* 请说明转化过程中在专利布局和保护上做了哪些工作：（非必填） */}
                  </label>
                </Col>
              </Row>

              <Row gutter={[16, 16]} style={{ marginTop: '15px' }}>
                <Col span={'11'}>
                  <Form.Item
                    name="converProcess"
                    rules={[
                      {
                        validator: async (_, names) => {
                          if ((names && names.trim().length < 10) || !names) {
                            return Promise.reject(
                              new Error('请输入至少10个字符')
                            )
                          }
                          return Promise.resolve()
                        },
                      },
                    ]}>
                    <Input.TextArea rows={4} />
                  </Form.Item>
                </Col>
                <Col span={'11'} offset={1}>
                  <Form.Item
                    name="converProcessFile"
                    valuePropName="fileList"
                    getValueFromEvent={normFile}>
                    <Upload
                      name="logo"
                      multiple
                      maxCount={5}
                      customRequest={(opt) => {
                        handleUpload(
                          opt,
                          converProcessFileUrl,
                          setConverProcessFileUrl,
                          setCpDefaultFileList
                        )
                      }}
                      beforeUpload={beforeUpload}
                      onRemove={(i) => {
                        //setProspectusUrl('');
                        removeUploadFile(
                          i,
                          converProcessFileUrl,
                          setConverProcessFileUrl
                        )
                      }}
                      fileList={otherFileList2}
                      defaultFileList={cpDefaultFileList}>
                      <Button className="uploadButton" type="default">
                        <div>上传转化凭证材料</div>
                        <div style={{ color: '#999999' }}>文件不大于50M</div>
                        <div style={{ color: '#999999' }}>支持PPT、PDF格式</div>
                      </Button>
                    </Upload>
                  </Form.Item>
                </Col>
              </Row>

              <Row gutter={[16, 16]}>
                <Col span={'11'}>
                  <label className="form-label">
                    请说明专利技术在产品中的实施状况：（非必填）自身产品或其它厂商产品，自主实施和/或由第三方机构实施情况，产生的市场价值、战略价值等。
                  </label>
                </Col>
                <Col span={'11'} offset={1}>
                  <label className="form-label">
                    请说明转化过程中在专利布局和保护上做了哪些工作：（非必填）
                  </label>
                </Col>
              </Row>

              <Row gutter={[16, 16]} style={{ marginTop: '15px' }}>
                <Col span={'11'}>
                  <Form.Item
                    name="implementStatus"
                    rules={[
                      {
                        validator: async (_, names) => {
                          if ((names && names.trim().length < 10) || !names) {
                            return Promise.reject(
                              new Error('请输入至少10个字符')
                            )
                          }
                          return Promise.resolve()
                        },
                      },
                    ]}>
                    <Input.TextArea rows={4} />
                  </Form.Item>
                </Col>
                <Col span={'11'} offset={1}>
                  <Form.Item
                    name="protectingWork"
                    rules={[
                      {
                        validator: async (_, names) => {
                          if ((names && names.trim().length < 10) || !names) {
                            return Promise.reject(
                              new Error('请输入至少10个字符')
                            )
                          }
                          return Promise.resolve()
                        },
                      },
                    ]}>
                    <Input.TextArea rows={4} />
                  </Form.Item>
                </Col>
              </Row>

              <br />
              <br />

              <button
                type="button"
                onClick={submitForm}
                // className={`${!agreementA || !agreementB ? 'blueButton event-disabled' : 'blueButton'}`}
                className="blueButton"
                style={{ marginTop: '35px', marginBottom: '50px' }}>
                提交报名信息
              </button>
            </Form>
          </>
        )}
      </>
    </div>
  )
}

export default Enterprise
